import { render } from "./Cart.vue?vue&type=template&id=0f8af029&bindings={\"currency\":\"options\",\"closeBasket\":\"options\"}"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"

import "./Cart.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script